/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { SvgzDocumentsControllerService } from './services/svgz-documents-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    SvgzDocumentsControllerService,
    ApiConfiguration
  ],
})
export class MyasiDocumentSvgzModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MyasiDocumentSvgzModule> {
    return {
      ngModule: MyasiDocumentSvgzModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MyasiDocumentSvgzModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MyasiDocumentSvgzModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
